<div class="home-recent-orders" *ngIf="orders?.length > 0">
    <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-sm-0">
      <h2 class="text-center">
        <span>RECENT ORDERS AND FAVORITES</span>
      </h2>
    </div>
  </div>
  <div role="group" aria-label="Recent Orders And Favorites" class="row visible-lg visible-md hidden-sm hidden-xs">
      <div class="order col-lg-4 col-md-4 col-sm-6 col-xs-6 " *ngFor="let order of orders">
        <a role="button" aria-label="Add Order To Cart" class="recent-order" (click)="addToCart(order)">
          <div class="lft-fav-div">
            <img src="{{order?.imageUrl}}" alt="{{order?.displayText}}" />
          </div>
          <div class="rgt-fav-div">
            <strong title="{{order?.displayText}}">{{order?.displayText | substring: desktopDisplayTextLimit: tail }}</strong>
            <p>{{order.itemCount}} item<span *ngIf="order.itemCount > 1">s</span></p>
          </div>
          <p class="order-btn">Order</p>
        </a>
      </div>
  </div>

  <!--mobile view-->
  <div class="hidden-lg hidden-md visible-sm visible-xs">
    <div class="mobile row flex-row flex-nowrap">
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 order" *ngFor="let order of orders">
      <a class="recent-order" (click)="addToCart(order)">
        <div class="lft-fav-div">
            <img src="{{order?.imageUrl}}" alt="item image" />
        </div>
        <div class="rgt-fav-div">
          <strong>{{order?.displayText | substring: mobileDisplayTextLimit: tail }}</strong>
          <p>{{order.itemCount}} item<span *ngIf="order.itemCount > 1">s</span></p>
        </div>
        <p class="order-btn">Order</p>
      </a>
    </div>
    </div>
  </div>
  <!-- mobile view-->
  <div class="clear-div text-center mg-top-10">
    <a class="view-fav-order" routerLink="/account" fragment="favoriteAnchor">View Favorite Orders</a>
  </div>
</div>
